<template lang='pug'>
.quiz#top
	//- Question one
	.view-pad(:class='{ one: current === 0, two: current === 1, three: current === 3, four: current === 2, five: current === 4, six: current === 5, seven: current === 6, eight: current === 7 }')
	.quiz-container.one.noselect(:class="{ left: current > 0 }")
		.pad-left
		.question.veneer
			.para Hvernig hellir þú upp á kaffi?
		.information.corpid.italic
		.answer-row-1.grid.corpid.bold.italic
			.answer-1.answer.hover(@click='answer("Pressukanna")' :class='{ active: state.answers[0].answer === "Pressukanna", hidden: (state.answers[0].answer !== "" && state.answers[0].answer !== "Pressukanna") }') Pressukanna
				.icon
			.answer-2.answer.hover(@click='answer("Uppáhellt")' :class='{ active: state.answers[0].answer === "Uppáhellt", hidden: (state.answers[0].answer !== "" && state.answers[0].answer !== "Uppáhellt") }') Uppáhellt
				.icon
			.answer-3.answer.hover(@click='answer("Mokkakanna")' :class='{ active: state.answers[0].answer === "Mokkakanna", hidden: (state.answers[0].answer !== "" && state.answers[0].answer !== "Mokkakanna") }') Mokkakanna
				.icon
			.answer-4.answer.hover(@click='answer("Baunavél")' :class='{ active: state.answers[0].answer === "Baunavél", hidden: (state.answers[0].answer !== "" && state.answers[0].answer !== "Baunavél") }') Baunavél
				.icon
		.answer-row-2.grid.corpid.bold.italic
			.answer-5.odd.answer.hover(@click='answer("Köld uppáhelling")' :class='{ active: state.answers[0].answer === "Köld uppáhelling", hidden: (state.answers[0].answer !== "" && state.answers[0].answer !== "Köld uppáhelling") }') Köld uppáhelling
				.icon
			.answer-6.odd.answer.hover(@click='answer("Expressóvél")' :class='{ active: state.answers[0].answer === "Expressóvél", hidden: (state.answers[0].answer !== "" && state.answers[0].answer !== "Expressóvél") }') Expressóvél
				.icon
			.answer-7.odd.wide.answer.hover(@click='answer("AeroPress")' :class='{ active: state.answers[0].answer === "AeroPress", hidden: (state.answers[0].answer !== "" && state.answers[0].answer !== "AeroPress") }') AeroPress
				.icon
		.skip.tk-proxima-nova.small.no-back
			.back.hover(@click='back')
			.next.hover.corpid.italic(@click='next' :class='{ active: state.answers[0].answer !== "" }') Næsta spurning
			.underline.first(:class='{ active: state.answers[0].answer !== "" }')
		.pad-right

	//- Question two
	.quiz-container.two.noselect(:class="{ left: current > 1, right: current < 1 }")
		.pad-left
		.question.veneer
			.para Hvernig kaffi drekkur þú?
		.information.corpid.italic
		.answer-row-1.grid.corpid.bold.italic
			.answer-1.wide.answer.hover(@click='answer("Svart")' :class='{ active: state.answers[1].answer["Svart"] }') Svart
				.icon
			.answer-2.wide.answer.hover(@click='answer("Með mjólk")' :class='{ active: state.answers[1].answer["Með mjólk"] }') Með mjólk
				.icon
			.answer-3.wide.answer.hover(@click='answer("Koffeinlaust")' :class='{ active: state.answers[1].answer["Koffeinlaust"] }') Koffeinlaust
				.icon
		.skip.tk-proxima-nova.small
			.back.hover.corpid.italic(@click='back') Til baka
			.next.hover.corpid.italic(@click='next') Næsta spurning
			.underline(:class='{ active: answerOne }')
		.pad-right

	//- Question three
	.quiz-container.four.noselect(:class="{ left: current > 2, right: current < 2 }")
		.pad-left
		.question.veneer
			.para Finnst þér bragðbætt síróp gott í kaffi?
		.information.corpid.italic
		.answer-row-1.grid.corpid.bold.italic
			.answer-1.no-icon.answer.hover(@click='answer("Já")' :class='{ active: state.answers[2].answer === "Já" }') Já
				.icon
			.answer-2.no-icon.answer.hover(@click='answer("Nei")' :class='{ active: state.answers[2].answer === "Nei" }') Nei
				.icon
			.answer-3.no-icon.answer.hover(@click='answer("Stundum")' :class='{ active: state.answers[2].answer === "Stundum" }') Stundum
				.icon
			.answer-4.no-icon.answer.hover(@click='answer("Ég veit ekki")' :class='{ active: state.answers[2].answer === "Ég veit ekki" }') Ég veit ekki
				.icon
		.skip.tk-proxima-nova.small
			.back.hover.corpid.italic(@click='back') Til baka
			.next.hover.corpid.italic(@click='next') Næsta spurning
			.underline(:class='{ active: answerTwo }')
		.pad-right

	//- Question four
	.quiz-container.three.noselect(:class="{ left: current > 3, right: current < 3 }")
		.pad-left
		.question.veneer
			.para Hvernig brennslu vilt þú?
		.information.corpid.italic
			.para Við <span class='bold'>meðal brennslu</span> njóta sín allir tónar kaffibragðsins og þá sérstaklega ávöxturinn. <br> Við <span class='bold'>vínar brennslu</span> hefur náttúrulegi sykurinn brúnast meira, fyllingin eykst og merkja má örlítinn brenndan keim. Í <br><span class='bold'>franskri brennslu</span> eru brenndir tónar fyrirferðarmestir í bragði og ávöxtur í bragði minnkar.
		.answer-row-1.slider.tk-proxima-nova
			.line
			.bean(:class='{ left: state.answers[3].answer === "Meðal brennslu", center: state.answers[3].answer === "Vínar brennslu", right: state.answers[3].answer === "Franska brennslu" }')
		.answer-row-2.slider.corpid.bold.italic
			.section.section-1.hover(@click='answer("Meðal brennslu")' :class='{ active: state.answers[3].answer === "Meðal brennslu" }') Meðal brennslu
			.section.section-2.hover(@click='answer("Vínar brennslu")' :class='{ active: state.answers[3].answer === "Vínar brennslu" }') Vínar brennslu
			.section.section-3.hover(@click='answer("Franska brennslu")' :class='{ active: state.answers[3].answer === "Franska brennslu" }') Franska brennslu
		.skip.tk-proxima-nova.small
			.back.hover.corpid.italic(@click='back') Til baka
			.next.hover.corpid.italic(@click='next') Næsta spurning
			.underline(:class='{ active: state.answers[3].answer !== "" }')
		.pad-right

	//- Question five
	.quiz-container.five.noselect(:class="{ left: current > 4, right: current < 4 }")
		.pad-left
		.question.veneer
			.para Hversu mikla fyllingu vilt þú í þitt kaffi?
		.information.corpid.italic
			.para Því meiri fylling því bragðmeira er kaffið og bragðið varir lengur í munni.
		.answer-row-1.slider.tk-proxima-nova
			.line
			.bean(:class='{ left: state.answers[4].answer === "Litla", center: state.answers[4].answer === "Meðal", right: state.answers[4].answer === "Mikla" }')
		.answer-row-2.slider.corpid.bold.italic
			.section.section-1.hover(@click='answer("Litla")' :class='{ active: state.answers[4].answer === "Litla" }') Litla
			.section.section-2.hover(@click='answer("Meðal")' :class='{ active: state.answers[4].answer === "Meðal" }') Meðal
			.section.section-3.hover(@click='answer("Mikla")' :class='{ active: state.answers[4].answer === "Mikla" }') Mikla
		.skip.tk-proxima-nova.small
			.back.hover.corpid.italic(@click='back') Til baka
			.next.hover.corpid.italic(@click='next') Næsta spurning
			.underline(:class='{ active: state.answers[4].answer !== "" }')
		.pad-right

	//- Question six
	.quiz-container.six.noselect(:class="{ left: current > 5, right: current < 5 }")
		.pad-left
		.question.veneer
			.para Hversu mikinn ávöxt vilt þú í þitt kaffi?
		.information.corpid.italic
			.para Því meiri ávöxtur því líflegra og oft sætara bragð er af kaffinu.
		.answer-row-1.slider.tk-proxima-nova
			.line
			.bean(:class='{ left: state.answers[5].answer === "Lítinn", center: state.answers[5].answer === "Meðal", right: state.answers[5].answer === "Mikinn" }')
		.answer-row-2.slider.corpid.bold.italic
			.section.section-1.hover(@click='answer("Lítinn")' :class='{ active: state.answers[5].answer === "Lítinn" }') Lítinn
			.section.section-2.hover(@click='answer("Meðal")' :class='{ active: state.answers[5].answer === "Meðal" }') Meðal
			.section.section-3.hover(@click='answer("Mikinn")' :class='{ active: state.answers[5].answer === "Mikinn" }') Mikinn
		.skip.tk-proxima-nova.small
			.back.hover.corpid.italic(@click='back') Til baka
			.next.hover.corpid.italic(@click='next') Næsta spurning
			.underline(:class='{ active: state.answers[5].answer !== "" }')
		.pad-right

	//- Question seven
	.quiz-container.seven.noselect(:class="{ left: current > 6, right: current < 6 }")
		.pad-left
		.question.veneer
			.para Hvaða bragðtóna vilt þú í þitt kaffi?
		.information.corpid.italic
			.para Í gæðakaffi má finna ýmsa bragðtóna líkt og í vínum ef vel er að gáð. Veldu eins marga og þú vilt.
		.answer-row-1.grid.corpid.bold.italic
			.answer-1.answer.hover(@click='answer("Sítrustóna")' :class='{ active: state.answers[6].answer["Sítrustóna"] }') Sítrustóna
				.icon
			.answer-2.answer.hover(@click='answer("Berjatóna")' :class='{ active: state.answers[6].answer["Berjatóna"] }') Berjatóna
				.icon
			.answer-3.answer.hover(@click='answer("Ávaxtatóna")' :class='{ active: state.answers[6].answer["Ávaxtatóna"] }') Ávaxtatóna
				.icon
			.answer-4.answer.hover(@click='answer("Blómlega tóna")' :class='{ active: state.answers[6].answer["Blómlega tóna"] }') Blómlega tóna
				.icon
			.answer-5.answer.hover(@click='answer("Kryddtóna")' :class='{ active: state.answers[6].answer["Kryddtóna"] }') Kryddtóna
				.icon
			.answer-6.answer.hover(@click='answer("Brennda tóna")' :class='{ active: state.answers[6].answer["Brennda tóna"] }') Brennda tóna
				.icon
			.answer-7.answer.hover(@click='answer("Sætutóna")' :class='{ active: state.answers[6].answer["Sætutóna"] }') Sætutóna
				.icon
			.answer-8.answer.hover(@click='answer("Karamellutóna")' :class='{ active: state.answers[6].answer["Karamellutóna"] }') Karamellutóna
				.icon
			.answer-9.answer.hover(@click='answer("Hnetutóna")' :class='{ active: state.answers[6].answer["Hnetutóna"] }') Hnetutóna
				.icon
			.answer-10.answer.hover(@click='answer("Súkkulaðitóna")' :class='{ active: state.answers[6].answer["Súkkulaðitóna"] }') Súkkulaðitóna
				.icon
		.skip.tk-proxima-nova.small
			.back.hover.corpid.italic(@click='back') Til baka
			.next.hover.corpid.italic(@click='next') Finna kaffi
			.underline(:class='{ active: answerSix }')
		.pad-right

	//- Result
	.result-header.veneer(v-if='current === 7') Þitt kaffi er í {{ translatedState }} flokknum
	.result-header.link.corpid(@click='visitKaffi(true)' v-if='current === 7') Skoða meira kaffi
	.result(:class="{ hidden: current < 7, left: state.focus === 0, center: state.focus === 1, right: state.focus === 2 }" v-touch:swipe='swipeFocus' v-if='')
		//- result 1
		.product1.product(@click='visitKaffi(false, 0)', v-if='state.result.length > 0' :class='{ focus: state.focus === 0, purple: state.result[1].marker === "purple", blue: state.result[1].marker === "blue", orange: state.result[1].marker === "orange", pink: state.result[1].marker === "pink" }')
			img.img(:src='state.result[1].image')
			.backdrop
			.top
				.description.corpid.italic {{ state.result[1].description }}
			.center
				.uppahelling
					p.head.corpid.italic Uppáhalds uppáhelling
					p.corpid.italic {{ state.result[1].uppahelling }}
				.locations
					p.head.corpid.italic Sölustaðir
					p.corpid.italic {{ state.result[1].locations }} (Fyrirvari: Kaffið getur verið uppselt tímabundið).
			.bottom
				.left(:class='{ purple: state.result[1].marker === "purple", blue: state.result[1].marker === "blue", orange: state.result[1].marker === "orange", pink: state.result[1].marker === "pink" }')
					.brennsla
						p.corpid.italic Brennsla
						.dot(:class='{ active: state.result[1].roast > 0 }')
						.dot(:class='{ active: state.result[1].roast > 1 }')
						.dot(:class='{ active: state.result[1].roast > 2 }')
					.fylling
						p.corpid.italic Fylling
						.dot(:class='{ active: state.result[1].fill > 0 }')
						.dot(:class='{ active: state.result[1].fill > 1 }')
						.dot(:class='{ active: state.result[1].fill > 2 }')
					.avoxtur
						p.corpid.italic Ávöxtur
						.dot(:class='{ active: state.result[1].fruit > 0 }')
						.dot(:class='{ active: state.result[1].fruit > 1 }')
						.dot(:class='{ active: state.result[1].fruit > 2 }')
				.right(:class='{ purple: state.result[1].marker === "purple", blue: state.result[1].marker === "blue", orange: state.result[1].marker === "orange", pink: state.result[1].marker === "pink" }')
					.above
						.bondi.corpid.italic Bóndi/býli
						p.corpid.italic {{ state.result[1].bondi }}
					.below
						.yrki.corpid.italic Yrki
						p.corpid.italic {{ state.result[1].yrki }}
		//- result 2
		.product2.product.big(@click='visitKaffi(false, 1)' v-if='state.result.length > 1' :class='{ focus: state.focus === 1, purple: state.result[1].marker === "purple", blue: state.result[1].marker === "blue", orange: state.result[1].marker === "orange", pink: state.result[1].marker === "pink" }')
			img.img(:src='state.result[0].image')
			.backdrop
			.top
				.description.corpid.italic {{ state.result[0].description }}
			.center
				.uppahelling
					p.head.corpid.italic Uppáhalds uppáhelling
					p.corpid.italic {{ state.result[0].uppahelling }}
				.locations
					p.head.corpid.italic Sölustaðir
					p.corpid.italic {{ state.result[0].locations }} (Fyrirvari: Kaffið getur verið uppselt tímabundið).
			.bottom
				.left
					.brennsla
						p.corpid.italic Brennsla
						.dot(:class='{ active: state.result[0].roast > 0 }')
						.dot(:class='{ active: state.result[0].roast > 1 }')
						.dot(:class='{ active: state.result[0].roast > 2 }')
					.fylling
						p.corpid.italic Fylling
						.dot(:class='{ active: state.result[0].fill > 0 }')
						.dot(:class='{ active: state.result[0].fill > 1 }')
						.dot(:class='{ active: state.result[0].fill > 2 }')
					.avoxtur
						p.corpid.italic Ávöxtur
						.dot(:class='{ active: state.result[0].fruit > 0 }')
						.dot(:class='{ active: state.result[0].fruit > 1 }')
						.dot(:class='{ active: state.result[0].fruit > 2 }')
				.right
					.above
						.bondi.corpid.italic Bóndi/býli
						p.corpid.italic {{ state.result[0].bondi }}
					.below
						.yrki.corpid.italic Yrki
						p.corpid.italic {{ state.result[0].yrki }}
		//- result 3
		.product3.product(@click='visitKaffi(false, 2)', v-if='state.result.length > 2' :class='{ focus: state.focus === 2, purple: state.result[1].marker === "purple", blue: state.result[1].marker === "blue", orange: state.result[1].marker === "orange", pink: state.result[1].marker === "pink" }')
			img.img(:src='state.result[2].image')
			.backdrop
			.top
				.description.corpid.italic {{ state.result[2].description }}
			.center
				.uppahelling
					p.head.corpid.italic Uppáhalds uppáhelling
					p.corpid.italic {{ state.result[2].uppahelling }}
				.locations
					p.head.corpid.italic Sölustaðir
					p.corpid.italic {{ state.result[2].locations }} (Fyrirvari: Kaffið getur verið uppselt tímabundið).
			.bottom
				.left
					.brennsla
						p.corpid.italic Brennsla
						.dot(:class='{ active: state.result[2].roast > 0 }')
						.dot(:class='{ active: state.result[2].roast > 1 }')
						.dot(:class='{ active: state.result[2].roast > 2 }')
					.fylling
						p.corpid.italic Fylling
						.dot(:class='{ active: state.result[2].fill > 0 }')
						.dot(:class='{ active: state.result[2].fill > 1 }')
						.dot(:class='{ active: state.result[2].fill > 2 }')
					.avoxtur
						p.corpid.italic Ávöxtur
						.dot(:class='{ active: state.result[2].fruit > 0 }')
						.dot(:class='{ active: state.result[2].fruit > 1 }')
						.dot(:class='{ active: state.result[2].fruit > 2 }')
				.right
					.above
						.bondi.corpid.italic Bóndi/býli
						p.corpid.italic {{ state.result[2].bondi }}
					.below
						.yrki.corpid.italic Yrki
						p.corpid.italic {{ state.result[2].yrki }}
	.result-back.veneer(v-if='current === 7')
		.retake(@click='restart') Taka prófið aftur
		.share(@click='share') Deila niðurstöðu
</template>

<script>
export default {
	name: 'Quiz',
	data: function () {
		return {
			current: 0,
			state: {
				focus: 1,
				result: [],
				answers: [
					{
						// 0
						multiple: false,
						// Pressukanna, Uppáhelt, Slow Brew, Chemex, Expresso, Aeropress, Cold Brew
						answer: ''
					},
					{
						// 1
						multiple: true,
						// Svart, Með mjólk, Koffeinlaust
						answer: {
							'Svart': false,
							'Með mjólk': false,
							'Koffeinlaust': false
						}
					},
					{
						// 2
						multiple: false,
						// Já, Nei, Stundum, Ég veit ekki
						answer: ''
					},
					{
						// 3
						multiple: false,
						// Meðal brennslu, Vínar brennslu, Franska Brennslu
						answer: 'Vínar brennslu'
					},
					{
						// 4
						multiple: false,
						// Litla, Meðal, Mikla
						answer: 'Meðal'
					},
					{
						// 5
						multiple: false,
						// Lítinn, Meðal, Mikinn
						answer: 'Meðal'
					},
					{
						// 6
						multiple: true,
						// Sítrustóna, Berjatóna, Ávaxtatóna, Blómlega tóna, Kryddtóna, Brennda tóna, Hnetutóna, Súkkulaðitóna, Karamellutóna, Sætutóna
						answer: {
							'Sítrustóna': false,
							'Berjatóna': false,
							'Ávaxtatóna': false,
							'Blómlega tóna': false,
							'Kryddtóna': false,
							'Brennda tóna': false,
							'Sætutóna': false,
							'Karamellutóna': false,
							'Hnetutóna': false,
							'Súkkulaðitóna': false
						}
					}
				]
			},
			coffee: {
				// 0
				'Morgundögg': {
					title: 'Morgundögg',
					description: 'Meðal brennsla. Ljúft kaffi með sætum hunangs- og berjatónum.',
					locations: 'Melabúðin, Fjarðarkaup, Hagkaup, Krónan, Nettó, Samkaup, Bónus.',
					uppahelling: 'Uppáhelling eða pressukanna.',
					bondi: 'Kaffiblanda frá Níkaragúa og Brasilíu.',
					yrki: 'Caturra og Bourbon.',
					image: '/static/packaging/orange/morgundogg.jpg',
					tones: ['hunang', 'ber', 'krydd', 'súkkulaði'],
					method: ['uppáhelling', 'pressukanna'],
					roast: 1,
					fill: 1,
					fruit: 2,
					milk: true,
					cold: false,
					marker: 'orange',
					rank: 0
				},
				// 1
				'Kvöldroði': {
					title: 'Kvöldroði',
					description: 'Vínar brennsla. Bragðmikið kaffi með dökkum kryddtónum.',
					locations: 'Melabúðin, Fjarðarkaup, Hagkaup, Nettó, Samkaup, Bónus.',
					uppahelling: 'Mokkakanna eða uppáhelling.',
					bondi: 'Kaffiblanda frá Níkaragúa og Brasilíu.',
					yrki: 'Caturra og Bourbon.',
					image: '/static/packaging/pink/kvoldrodi.png',
					tones: ['brenndur keimur', 'dökk ber', 'karamella', 'krydd'],
					method: ['mokkakanna', 'uppáhelling', 'baunavél', 'expressóvel'],
					roast: 2,
					fill: 2,
					fruit: 2,
					milk: true,
					cold: false,
					marker: 'pink',
					rank: 0
				},
				// 2
				'Expressó': {
					title: 'Expressó',
					description: 'Frönsk brennsla. Mikið brennt og kröftugt kaffi.',
					locations: 'Melabúðin, Fjarðarkaup, Hagkaup, Nettó, Samkaup, Bónus.',
					uppahelling: 'Expressóvél eða baunavél.',
					bondi: 'Kaffiblanda frá Mið- og Suður-Ameríku.',
					yrki: 'Caturra og Bourbon.',
					image: '/static/packaging/blue/expresso.png',
					tones: ['brenndur keimur', 'súkkulaði'],
					method: ['expressóvél', 'baunavél'],
					roast: 3,
					fill: 3,
					fruit: 1,
					milk: true,
					cold: true,
					marker: 'blue',
					rank: 0
				},
				// 3
				'Brazilia Lífræn': {
					title: 'Brazilia Lífræn',
					description: 'Meðal brennsla. Bragðmikið, tært kaffi með kryddtónum og vott af ávexti sem minnir á papæja og plómur.',
					locations: 'Kaffihús Kaffitárs.',
					uppahelling: 'Uppáhelling eða expressóvél.',
					bondi: 'Luis Pascal, Daterra, Brasilía.',
					yrki: 'Organic Icatú.',
					image: '/static/packaging/orange/brasilia_lifraen.png',
					tones: ['krydd', 'hnetur', 'karamella', 'ávextir'],
					method: ['uppáhelling', 'baunavél', 'expressóvél'],
					roast: 1,
					fill: 2,
					fruit: 2,
					milk: false,
					cold: true,
					marker: 'orange',
					rank: 0
				},
				// 4
				'Brazilia Sunrise': {
					title: 'Brazilia Sunrise',
					description: 'Vínar brennsla. Bragðmikið kaffi með ávæning af kakónibbum, hnetum og ávöxtum.',
					locations: 'Kaffihús Kaffitárs - Melabúðin, Fjarðarkaup, Hagkaup.',
					uppahelling: 'Uppáhelling eða expressóvél.',
					bondi: 'Luis Pascal, Daterra, Brasilía.',
					yrki: 'Iac Rn 125 og Mundo Novo.',
					image: '/static/packaging/pink/brasilia.png',
					tones: ['hnetur', 'kakó', 'ávextir'],
					method: ['uppáhelling', 'baunavél', 'expressóvél'],
					roast: 2,
					fill: 2,
					fruit: 2,
					milk: true,
					cold: true,
					marker: 'pink',
					rank: 0
				},
				// 5
				'Brazilia Sweet Collection': {
					title: 'Brazilia Sweet Collection',
					description: 'Meðal brennsla. Bragðmikið kaffi þar sem tónar af vanillu og karamellu renna ljúflega saman með sætri ferskju.',
					locations: 'Kaffihús Kaffitárs.',
					uppahelling: 'Uppáhelling eða pressukanna.',
					bondi: 'Luis Pascal, Daterra, Brasilía. "Collection" eru handvaldar baunir úr hæsta gæðaflokki.',
					yrki: 'Acaía og gult og rautt Catuai.',
					image: '/static/packaging/orange/brasilia_sweet.png',
					tones: ['vanilla', 'karamella', 'ávextir'],
					method: ['uppáhelling', 'pressukanna', 'baunavél', 'expressóvél'],
					roast: 1,
					fill: 2,
					fruit: 2,
					milk: true,
					cold: true,
					marker: 'orange',
					rank: 0
				},
				// 6
				/*
				'Gvatemala El Injerto': {
					title: 'Gvatemala El Injerto',
					description: 'Meðal brennsla. Ljúft kaffi þar sem sæta og krydd blandast í jafnvægi við dökkt súkkulaði.',
					locations: 'Kaffihús Kaffitárs, Melabúðin, Fjarðarkaup, Hagkaup.',
					uppahelling: 'Uppáhelling eða pressukanna.',
					bondi: 'Arturo Aguirre El Injerto, Huehuetenango, Gvatemala.',
					yrki: 'Bourbon og Catuai.',
					image: '/static/packaging/orange/gvatemala_el.png',
					tones: ['ávextir', 'krydd', 'dökkt súkkulaði'],
					method: ['uppáhelling', 'pressukanna'],
					roast: 1,
					fill: 1,
					fruit: 2,
					milk: true,
					cold: true,
					marker: 'orange',
					rank: 0
				},
				*/
				// 7
				/*
				'Gvatemala Piedra Azúl': {
					title: 'Gvatemala Piedra Azúl',
					description: 'Meðal brennsla. Ljúft kaffi með tónum af appelsínuberki og vott af ristuðum hnetum.',
					locations: 'Kaffihús Kaffitárs, Melabúðin, Fjarðarkaup, Hagkaup.',
					uppahelling: 'Uppáhelling og pressukanna.',
					bondi: 'Renardo Ovalle, Piedra Azul, Huehuetenango, Gvatemala.',
					yrki: 'Bourbon og Caturra.',
					image: '/static/packaging/orange/gvatemala_pie.png',
					tones: ['hnetur', 'súkkulaði'],
					method: ['uppáhelling', 'pressukanna', 'baunavél'],
					roast: 1,
					fill: 1,
					fruit: 2,
					milk: true,
					cold: false,
					marker: 'orange',
					rank: 0
				},
				*/
				// 8
				'Húsblanda Expressó': {
					title: 'Húsblanda Expressó',
					description: 'Frönsk brennsla. Bragðmikið kaffi með tónum af dökku súkkulaði, kryddi, hunangi og sætum lakkrís.',
					locations: 'Kaffihús Kaffitárs, Melabúðin, Fjarðarkaup, Hagkaup.',
					uppahelling: 'Expressóvél eða baunavél.',
					bondi: 'Kaffiblanda frá Indónesíu, Mið- og Suður-Ameríku.',
					yrki: 'Caturra, Bourbon og Catuai.',
					image: '/static/packaging/blue/husblanda.png',
					tones: ['súkkulaði', 'krydd', 'hunang'],
					method: ['expressóvél', 'baunavél'],
					roast: 3,
					fill: 2,
					fruit: 1,
					milk: true,
					cold: true,
					marker: 'blue',
					rank: 0
				},
				// 9
				/*
				'Kenía Gutumbu Muranga': {
					title: 'Kenía Gutumbu Muranga',
					description: 'Meðal brennsla. Bragðmikið kaffi í fullkomnu jafnvægi með ávaxtaríkri sýrni og tónum af sykurreyr.',
					locations: 'Kaffihús Kaffitárs.',
					uppahelling: 'Uppáhelling og pressukanna.',
					bondi: 'Smábændur í Kaiambuhéraði, Kenía.',
					yrki: 'Sl.28, Sl.34 og Ruiru 11.',
					image: '/static/packaging/orange/kenia.png',
					tones: ['ber', 'ávextir', 'sítrus'],
					method: ['uppáhelling', 'pressukanna'],
					roast: 1,
					fill: 2,
					fruit: 3,
					milk: false,
					cold: true,
					marker: 'orange',
					rank: 0
				},
				*/
				// 10
				'Koffeinlaust kaffi': {
					title: 'Koffeinlaust kaffi',
					description: 'Meðal brennsla. Ljúft kaffi í góðu jafnvægi með súkkulaðitóna og kryddaðan eftirkeim.',
					locations: 'Kaffihús Kaffitárs, Melabúðin, Fjarðarkaup, Hagkaup.',
					uppahelling: 'Uppáhelling og expressóvél.',
					bondi: 'Andes Amazonicos samvinnufélag, Lonya Grande, Amazonas, Perú.',
					yrki: 'Typica, Pache, Caturra.',
					image: '/static/packaging/pink/koffeinlaust.png',
					tones: ['súkkulaði', 'krydd', 'ávextir'],
					method: ['uppáhelling', 'baunavél', 'expressóvél'],
					roast: 2,
					fill: 2,
					fruit: 2,
					milk: true,
					cold: false,
					marker: 'pink',
					rank: 0
				},
				// 11
				/*
				'Kólumbía Popayan': {
					title: 'Kólumbía Popayan',
					description: 'Meðal brennsla. Ljúft kaffi með sítrusávexti og sætu sem minnir á sykurhúðaðar hnetur.',
					locations: 'Kaffihús Kaffitárs, Melabúðin, Fjarðarkaup, Hagkaup.',
					uppahelling: 'Uppáhelling eða pressukanna.',
					bondi: 'Samyrkjubú Caficultores, Popayan, Cauca, Kólumbía.',
					yrki: 'Caturra og Castillo.',
					image: '/static/packaging/orange/kolumbia.png',
					tones: ['sítrus', 'ávöxtur', 'hnetur', 'karamella'],
					method: ['uppáhelling', 'pressukanna', 'baunavél'],
					roast: 1,
					fill: 2,
					fruit: 2,
					milk: true,
					cold: true,
					marker: 'orange',
					rank: 0
				},
				*/
				// 12
				'Krakatá': {
					title: 'Krakatá',
					description: 'Vínar brennsla. Bragðmikið kaffi með súkkulaðitónum og örlitlu, sykurkenndu eftirbragði.',
					locations: 'Kaffihús Kaffitárs.',
					uppahelling: 'Expressóvél eða baunavél.',
					bondi: 'Kaffiblanda frá Mið-Ameríku og Indónesíu.',
					yrki: 'Typica og Catuai.',
					image: '/static/packaging/blue/krakata.png',
					tones: ['súkkulaði', 'krydd'],
					method: ['expressóvél', 'baunavél'],
					roast: 2,
					fill: 2,
					fruit: 1,
					milk: true,
					cold: false,
					marker: 'blue',
					rank: 0
				},
				// 13
				'Sumatra Raja Gayo': {
					title: 'Sumatra Raja Gayo',
					description: 'Vínar brennsla. Bragðmikið kaffi með tónum af múskati, dökku súkkulaði, ávöxtum, hlynsírópi og sætri ferskju.',
					locations: 'Kaffihús Kaffitárs, Melabúðin, Fjarðarkaup, Hagkaup.',
					uppahelling: 'Expressóvél eða uppáhelling.',
					bondi: 'Gayo samvinnufélag, Súmatra.',
					yrki: 'Typica, Gult Catuai, Arobusta og Juria.',
					image: '/static/packaging/pink/sumatra.png',
					tones: ['krydd', 'súkkulaði', 'ávextir', 'hlynsíróp'],
					method: ['uppáhelling', 'expressóvél', 'baunavél'],
					roast: 2,
					fill: 2,
					fruit: 2,
					milk: true,
					cold: true,
					marker: 'pink',
					rank: 0
				},
				// 14
				'Selebes': {
					title: 'Selebes',
					description: 'Vínar brennsla. Bragðmikið kaffi með mjúka tóna af kryddi, plómu og hlynsírópi.',
					locations: 'Kaffihús Kaffitárs, Melabúðin, Fjarðarkaup, Hagkaup.',
					uppahelling: 'Uppáhelling eða expressóvél.',
					bondi: 'Smábændur frá Toraja, Súlavesi, Indonesiu.',
					yrki: 'S795',
					image: '/static/packaging/blue/selebes.png',
					tones: ['krydd', 'hlynsíróp', 'plóma'],
					method: ['uppáhelling', 'expressóvél', 'baunavél'],
					roast: 2,
					fill: 2,
					fruit: 1,
					milk: true,
					cold: false,
					marker: 'blue',
					rank: 0
				},
				// 15
				'Mokkatár': {
					title: 'Mokkatár',
					description: 'Vínar brennsla. Bragðmikið kaffi með sætri fyllingu og dökkum kryddtónum.',
					locations: 'Kaffihús Kaffitárs.',
					uppahelling: 'Expressóvél eða baunavél.',
					bondi: 'Kaffiblanda frá Kólumbíu, Níkaragúa og Brasilíu.',
					yrki: 'Caturra, Catuai og Bourbon.',
					image: '/static/packaging/blue/mokkatar.png',
					tones: ['krydd', 'karamella'],
					method: ['expressóvél', 'baunavél'],
					roast: 2,
					fill: 2,
					fruit: 2,
					milk: true,
					cold: false,
					marker: 'blue',
					rank: 0
				},
				// 16
				'Vínarvals': {
					title: 'Vínarvals',
					description: 'Vínar brennsla. Bragðmikið kaffi með sætan, brenndan eftirkeim.',
					locations: 'Kaffihús Kaffitárs.',
					uppahelling: 'Expressóvél eða baunavél.',
					bondi: 'Ricardo Rosales, Jesus Maria, Níkaragúa.',
					yrki: 'Caturra, Catuai og Bourbon.',
					image: '/static/packaging/pink/vinarvals.png',
					tones: ['dökk ber', 'brenndur keimur', 'krydd', 'karamella'],
					method: ['uppáhelling', 'expressóvél', 'baunavél'],
					roast: 2,
					fill: 2,
					fruit: 2,
					milk: true,
					cold: false,
					marker: 'pink',
					rank: 0
				},
				// 17
				/*
				'Vínarkaffi': {
					title: 'Vínarkaffi',
					description: 'Vínar brennsla. Bragðmikið kaffi með tónum af súkkulaði og ávöxtum ásamt dökku kryddi í lokin.',
					locations: 'Kaffihús Kaffitárs.',
					uppahelling: 'Expressóvél eða baunavél.',
					bondi: 'Renardo Ovalle, Piedra Azul, Huehuetenango, Gvatemala.',
					yrki: 'Bourbon og Caturra.',
					image: '/static/packaging/pink/vinarkaffi.png',
					tones: ['súkkulaði', 'ávextir', 'krydd'],
					method: ['uppáhelling', 'expressóvél', 'baunavél'],
					roast: 2,
					fill: 2,
					fruit: 2,
					milk: true,
					cold: false,
					marker: 'pink',
					rank: 0
				},
				*/
				// 18
				'Eþíópía Chelelektu': {
					title: 'Eþíópía Chelelektu',
					description: 'Meðal brennsla. Bragðmikið kaffi með angan af jasmínu og bragðtóna af appelsínu og sætri ferskju.',
					locations: 'Kaffihús Kaffitárs.',
					uppahelling: 'Uppáhelling eða pressukanna.',
					bondi: 'Smábændur í Kochera, Yirgacheff, Eþíópíu.',
					yrki: 'Heirloom.',
					image: '/static/packaging/orange/ethiopia.png',
					tones: ['blómlegt', 'sítrus', 'ávextir'],
					method: ['uppáhelling', 'pressukanna'],
					roast: 1,
					fill: 2,
					fruit: 3,
					milk: false,
					cold: true,
					marker: 'orange',
					rank: 0
				},
				// 19
				'karamella bragðbætt': {
					title: 'karamella bragðbætt',
					description: 'Bragðbætt kaffi með miklu bragði af saltaðri rjómakaramellu. Hentar vel með mjólk.',
					locations: 'Kaffihús Kaffitárs - Melabúðin, Fjarðarkaup, Hagkaup, Krónan, Nettó, Samkaup.',
					uppahelling: 'Uppáhelling eða pressukanna.',
					bondi: 'Kaffiblanda frá Níkaragúa og Brasilíu.',
					yrki: 'Bragðefnin sem við notum eru olíur og eru án allra sætuefna.',
					image: '/static/packaging/purple/karamella.png',
					tones: ['karamella'],
					method: ['uppáhelling', 'pressukanna'],
					roast: 1,
					fill: 1,
					fruit: 2,
					milk: true,
					cold: true,
					marker: 'purple',
					rank: 0
				},
				// 20
				'Kókós bragðbætt': {
					title: 'Kókós bragðbætt',
					description: 'Bragðbætt kaffi með þykku bragði af kókoshnetu. Hentar vel með mjólk.',
					locations: 'Kaffihús Kaffitárs - Melabúðin, Fjarðarkaup, Hagkaup, Samkaup.',
					uppahelling: 'Uppáhelling eða pressukanna.',
					bondi: 'Kaffiblanda frá Níkaragúa og Brasilíu.',
					yrki: 'Bragðefnin sem við notum eru olíur og eru án allra sætuefna.',
					image: '/static/packaging/purple/kokos.png',
					tones: ['kókos'],
					method: ['uppáhelling', 'pressukanna'],
					roast: 1,
					fill: 1,
					fruit: 2,
					milk: true,
					cold: true,
					marker: 'purple',
					rank: 0
				},
				// 21
				'súkkulaði og möndlu bragðbætt': {
					title: 'súkkulaði og möndlu bragðbætt',
					description: 'Bragðbætt kaffi með súkkulaði og eftirkeim af möndlum. Hentar vel með mjólk.',
					locations: 'Kaffihús Kaffitárs - Melabúðin, Fjarðarkaup, Hagkaup, Krónan, Nettó, Samkaup, Bónus.',
					uppahelling: 'Uppáhelling eða pressukanna.',
					bondi: 'Kaffiblanda frá Níkaragúa og Brasilíu.',
					yrki: 'Bragðefnin sem við notum eru olíur og eru án allra sætuefna.',
					image: '/static/packaging/purple/sukkuladi.png',
					tones: ['súkkulaði', 'hnetur'],
					method: ['uppáhelling', 'pressukanna'],
					roast: 1,
					fill: 1,
					fruit: 2,
					milk: true,
					cold: true,
					marker: 'purple',
					rank: 0
				},
				// 22
				'Honduras Finca La Hacienda': {
					title: 'Honduras Finca La Hacienda',
					description: 'Meðal brennsla. Bragðmikið kaffi með tónum af súkkulaði og sætum ávexti.',
					locations: 'Kaffihús Kaffitárs.',
					uppahelling: 'Uppáhelling eða pressukanna.',
					bondi: 'Marden og Miriam Flores, Finca La Hacienda, El Paraiso, Hondúras.',
					yrki: 'Colombia, Lempira Rarainema.',
					image: '/static/packaging/orange/honduras.png',
					tones: ['súkkulaði', 'ávextir'],
					method: ['uppáhelling', 'pressukanna'],
					roast: 1,
					fill: 1,
					fruit: 2,
					milk: false,
					cold: true,
					marker: 'orange',
					rank: 0
				}
			}
		};
	},
	watch: {
		current: function () {
			if (this.current === 0) {
				this.$router.replace('/hver_er_þín_uppáhalds_uppáhelling_heima_hjá_þér');
			} else if (this.current === 1) {
				this.$router.replace('/hvernig_velur_þú_kaffið_þitt');
			} else if (this.current === 2) {
				this.$router.replace('/elskar_þú_bragðbætt_síróp_í_kaffið');
			} else if (this.current === 3) {
				this.$router.replace('/hvernig_brennslu_elskar_þú');
			} else if (this.current === 4) {
				this.$router.replace('/hversu_mikla_fyllingu_vilt_þú_í_þitt_kaffi');
			} else if (this.current === 5) {
				this.$router.replace('/hversu_mikinn_ávöxt_vilt_þú_í_þitt_kaffi');
			} else if (this.current === 6) {
				this.$router.replace('/hvaða_bragðtónar_þykir_þér_spennandi_í_kaffi');
			} else if (this.current === 7) {
				this.$router.replace('/niðurstaða');
			}
		},
		$route (to, from) {
			if (this.$route.params.current === 'hver_er_þín_uppáhalds_uppáhelling_heima_hjá_þér') {
				this.current = 0;
			} else if (this.$route.params.current === 'hvernig_velur_þú_kaffið_þitt') {
				this.current = 1;
			} else if (this.$route.params.current === 'elskar_þú_bragðbætt_síróp_í_kaffið') {
				this.current = 2;
			} else if (this.$route.params.current === 'hvernig_brennslu_elskar_þú') {
				this.current = 3;
			} else if (this.$route.params.current === 'hversu_mikla_fyllingu_vilt_þú_í_þitt_kaffi') {
				this.current = 4;
			} else if (this.$route.params.current === 'hversu_mikinn_ávöxt_vilt_þú_í_þitt_kaffi') {
				this.current = 5;
			} else if (this.$route.params.current === 'hvaða_bragðtónar_þykir_þér_spennandi_í_kaffi') {
				this.current = 6;
			} else if (this.$route.params.current === 'niðurstaða') {
				this.current = 7;
			}
		}
	},
	created: function () {
		if (this.$route.params.current === undefined || this.$route.params.current !== 'hver_er_þín_uppáhalds_uppáhelling_heima_hjá_þér') {
			this.$router.push('/hver_er_þín_uppáhalds_uppáhelling_heima_hjá_þér');
		}
		this.$nextTick(() => {
			let width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
			if (width < 441) {
				document.getElementsByClassName('result')[0].removeAttribute('style');
			}
		});
		window.onresize = () => {
			let width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
			if (width < 441) {
				document.getElementsByClassName('result')[0].removeAttribute('style');
			} else {
				let att = document.createAttribute('style');
				att.value = 'touch-action: none; user-select: none; -webkit-user-drag: none; -webkit-tap-highlight-color: rgba(0, 0, 0, 0);';
				document.getElementsByClassName('result')[0].setAttributeNode(att);
			}
		};
	},
	computed: {
		translatedState: function () {
			if (this.state.result[0]) {
				if (this.state.result[0].marker === 'purple') {
					return 'fjólubláa';
				} else if (this.state.result[0].marker === 'orange') {
					return 'appelsínugula';
				} else if (this.state.result[0].marker === 'pink') {
					return 'bleika';
				} else if (this.state.result[0].marker === 'blue') {
					return 'bláa';
				}
			} else {
				return '';
			}
		},
		answerOne: function () {
			if (this.state.answers[1].answer['Svart']) {
				return true;
			} else if (this.state.answers[1].answer['Með mjólk']) {
				return true;
			} else if (this.state.answers[1].answer['Koffeinlaust']) {
				return true;
			}
			return false;
		},
		answerTwo: function () {
			if (this.state.answers[2].answer === 'Já') {
				return true;
			} else if (this.state.answers[2].answer === 'Nei') {
				return true;
			} else if (this.state.answers[2].answer === 'Stundum') {
				return true;
			} else if (this.state.answers[2].answer === 'Ég veit ekki') {
				return true;
			}
			return false;
		},
		answerSix: function () {
			if (this.state.answers[6].answer['Sítrustóna']) {
				return true;
			} else if (this.state.answers[6].answer['Berjatóna']) {
				return true;
			} else if (this.state.answers[6].answer['Ávaxtatóna']) {
				return true;
			} else if (this.state.answers[6].answer['Blómlega tóna']) {
				return true;
			} else if (this.state.answers[6].answer['Kryddtóna']) {
				return true;
			} else if (this.state.answers[6].answer['Brennda tóna']) {
				return true;
			} else if (this.state.answers[6].answer['Sætutóna']) {
				return true;
			} else if (this.state.answers[6].answer['Karamellutóna']) {
				return true;
			} else if (this.state.answers[6].answer['Hnetutóna']) {
				return true;
			} else if (this.state.answers[6].answer['Súkkulaðitóna']) {
				return true;
			}

			return false;
		}
	},
	methods: {
		share: function () {
			window.FB.ui({
				method: 'share_open_graph',
				action_type: 'og.shares',
				action_properties: JSON.stringify({
					object: {
						'og:url': 'http://profid.kaffitar.is',
						'og:title': `Kaffið mitt er í ${this.translatedState} flokknum`,
						'og:description': 'Taktu Kaffitársprófið og þú finnur þitt uppáhalds kaffi.',
						'og:image': `http://profid.kaffitar.is/${this.state.result[0].image}`
					}
				})
			});
		},
		visitKaffi: function (force, num) {
			if (force) {
				window.open('https://kaffitar.is/vefverslun/c/kaffi/', '_blank');
			} else {
				let width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
				if (width > 1366) {
					window.open('https://kaffitar.is/vefverslun/c/kaffi/', '_blank');
				} else if (width > 440) {
					this.setFocus(num);
				}
			}
		},
		restart: function () {
			this.state.answers = [
				{
					multiple: false,
					answer: ''
				},
				{
					multiple: true,
					answer: {
						'Svart': false,
						'Með mjólk': false,
						'Koffeinlaust': false
					}
				},
				{
					multiple: false,
					answer: ''
				},
				{
					multiple: false,
					answer: 'Vínar brennslu'
				},
				{
					multiple: false,
					answer: 'Meðal'
				},
				{
					multiple: false,
					answer: 'Meðal'
				},
				{
					multiple: true,
					answer: {
						'Sítrustóna': false,
						'Berjatóna': false,
						'Ávaxtatóna': false,
						'Blómlega tóna': false,
						'Kryddtóna': false,
						'Brennda tóna': false,
						'Sætutóna': false,
						'Karamellutóna': false,
						'Hnetutóna': false,
						'Súkkulaðitóna': false
					}
				}
			];
			this.$emit('show');
			this.current = 0;
		},
		swipeFocus: function (direction) {
			if (direction === 'swipeleft') {
				if (this.state.focus < 2) {
					this.state.focus++;
				}
			} else if (direction === 'swiperight') {
				if (this.state.focus > 0) {
					this.state.focus--;
				}
			} else if (direction === 'swipedown') {
				this.$SmoothScroll(document.getElementById('app'), 300, null, null, 'y');
			} else if (direction === 'swipeup') {
				this.$SmoothScroll(document.getElementById('dots-bottom'), 300, null, null, 'y');
			}
		},
		setFocus: function (num) {
			console.log(num);
			this.state.focus = num;
		},
		home: function () {
			if (this.current === 7) {
				this.current = 0;
			}
		},
		back: function () {
			if (this.current > 0) {
				this.current -= 1;
				this.$SmoothScroll(document.getElementById('app'), 300, null, null, 'y');
			}
		},
		next: function () {
			// Resetting ranks
			for (let key in this.coffee) {
				if (!this.coffee.hasOwnProperty(key)) continue;
				this.coffee[key].rank = 0;
			}
			// QUESTION 1
			if (this.state.answers[0].answer === 'Pressukanna' || this.state.answers[0].answer === 'AeroPress') {
				for (let key in this.coffee) {
					if (!this.coffee.hasOwnProperty(key)) continue;
					if (this.coffee[key].method.includes('pressukanna')) {
						this.coffee[key].rank++;
					}
				}
			} else if (this.state.answers[0].answer === 'Uppáhellt') {
				for (let key in this.coffee) {
					if (!this.coffee.hasOwnProperty(key)) continue;
					if (this.coffee[key].method.includes('uppáhelling')) {
						this.coffee[key].rank++;
					}
				}
			} else if (this.state.answers[0].answer === 'Mokkakanna' || this.state.answers[0].answer === 'Expressóvél') {
				for (let key in this.coffee) {
					if (!this.coffee.hasOwnProperty(key)) continue;
					if (this.coffee[key].method.includes('expressóvél')) {
						this.coffee[key].rank++;
					}
				}
			} else if (this.state.answers[0].answer === 'Baunavél') {
				for (let key in this.coffee) {
					if (!this.coffee.hasOwnProperty(key)) continue;
					if (this.coffee[key].method.includes('baunavél')) {
						this.coffee[key].rank++;
					}
				}
			} else if (this.state.answers[0].answer === 'Köld uppáhelling') {
				for (let key in this.coffee) {
					if (!this.coffee.hasOwnProperty(key)) continue;
					if (this.coffee[key].cold) {
						this.coffee[key].rank++;
					}
				}
			}

			// QUESTION 2
			if (this.state.answers[1].answer['Svart']) {
				for (let key in this.coffee) {
					if (!this.coffee.hasOwnProperty(key)) continue;
					if (!this.coffee[key].milk) {
						this.coffee[key].rank++;
					}
				}
			} else if (this.state.answers[1].answer['Með mjólk']) {
				for (let key in this.coffee) {
					if (!this.coffee.hasOwnProperty(key)) continue;
					if (this.coffee[key].milk) {
						this.coffee[key].rank++;
					}
				}
			}

			if (this.state.answers[1].answer['Koffeinlaust']) {
				// giving this one some massive weight to guarantee it as a result
				this.coffee['Koffeinlaust kaffi'].rank += 100;
			}

			// QUESTION 3
			if (this.state.answers[2].answer === 'Já') {
				for (let key in this.coffee) {
					if (!this.coffee.hasOwnProperty(key)) continue;
					if (this.coffee[key].marker === 'purple') {
						this.coffee[key].rank += 10;
					}
				}
			} else if (this.state.answers[2].answer === 'Nei') {
				for (let key in this.coffee) {
					if (!this.coffee.hasOwnProperty(key)) continue;
					if (this.coffee[key].marker !== 'purple') {
						this.coffee[key].rank++;
					}
				}
			}

			// QUESTION 4
			if (this.state.answers[3].answer === 'Meðal brennslu') {
				for (let key in this.coffee) {
					if (!this.coffee.hasOwnProperty(key)) continue;
					if (this.coffee[key].roast === 1) {
						this.coffee[key].rank++;
					}
				}
			} else if (this.state.answers[3].answer === 'Vínar brennslu') {
				for (let key in this.coffee) {
					if (!this.coffee.hasOwnProperty(key)) continue;
					if (this.coffee[key].roast === 2) {
						this.coffee[key].rank++;
					}
				}
			} else if (this.state.answers[3].answer === 'Franska brennslu') {
				for (let key in this.coffee) {
					if (!this.coffee.hasOwnProperty(key)) continue;
					if (this.coffee[key].roast === 3) {
						this.coffee[key].rank++;
					}
				}
			}

			// QUESTION 5
			if (this.state.answers[4].answer === 'Litla') {
				for (let key in this.coffee) {
					if (!this.coffee.hasOwnProperty(key)) continue;
					if (this.coffee[key].fill === 1) {
						this.coffee[key].rank++;
					}
				}
			} else if (this.state.answers[4].answer === 'Meðal') {
				for (let key in this.coffee) {
					if (!this.coffee.hasOwnProperty(key)) continue;
					if (this.coffee[key].fill === 2) {
						this.coffee[key].rank++;
					}
				}
			} else if (this.state.answers[4].answer === 'Mikla') {
				for (let key in this.coffee) {
					if (!this.coffee.hasOwnProperty(key)) continue;
					if (this.coffee[key].fill === 3) {
						this.coffee[key].rank++;
					}
				}
			}

			// QUESTION 6
			if (this.state.answers[5].answer === 'Lítinn') {
				for (let key in this.coffee) {
					if (!this.coffee.hasOwnProperty(key)) continue;
					if (this.coffee[key].fruit === 1) {
						this.coffee[key].rank++;
					}
				}
			} else if (this.state.answers[5].answer === 'Meðal') {
				for (let key in this.coffee) {
					if (!this.coffee.hasOwnProperty(key)) continue;
					if (this.coffee[key].fruit === 2) {
						this.coffee[key].rank++;
					}
				}
			} else if (this.state.answers[5].answer === 'Mikinn') {
				for (let key in this.coffee) {
					if (!this.coffee.hasOwnProperty(key)) continue;
					if (this.coffee[key].fruit === 3) {
						this.coffee[key].rank++;
					}
				}
			}

			// QUESTION 6
			if (this.state.answers[6].answer['Sítrustóna']) {
				// sítrus
				for (let key in this.coffee) {
					if (!this.coffee.hasOwnProperty(key)) continue;
					if (this.coffee[key].tones.includes('sítrus')) {
						this.coffee[key].rank++;
					}
				}
			}
			if (this.state.answers[6].answer['Berjatóna']) {
				// ber, dökk ber
				for (let key in this.coffee) {
					if (!this.coffee.hasOwnProperty(key)) continue;
					if (this.coffee[key].tones.includes('ber') || this.coffee[key].tones.includes('dökk ber')) {
						this.coffee[key].rank++;
					}
				}
			}
			if (this.state.answers[6].answer['Ávaxtatóna']) {
				// ávextir, ávöxtur
				for (let key in this.coffee) {
					if (!this.coffee.hasOwnProperty(key)) continue;
					if (this.coffee[key].tones.includes('ávextir') || this.coffee[key].tones.includes('ávöxtur')) {
						this.coffee[key].rank++;
					}
				}
			}
			if (this.state.answers[6].answer['Blómlega tóna']) {
				// blómlegt
				for (let key in this.coffee) {
					if (!this.coffee.hasOwnProperty(key)) continue;
					if (this.coffee[key].tones.includes('blómlegt')) {
						this.coffee[key].rank++;
					}
				}
			}
			if (this.state.answers[6].answer['Kryddtóna']) {
				// krydd
				for (let key in this.coffee) {
					if (!this.coffee.hasOwnProperty(key)) continue;
					if (this.coffee[key].tones.includes('krydd')) {
						this.coffee[key].rank++;
					}
				}
			}
			if (this.state.answers[6].answer['Brennda tóna']) {
				// brenndur keimur
				for (let key in this.coffee) {
					if (!this.coffee.hasOwnProperty(key)) continue;
					if (this.coffee[key].tones.includes('brenndur keimur')) {
						this.coffee[key].rank++;
					}
				}
			}
			if (this.state.answers[6].answer['Sætutóna']) {
				// hunang, vanilla, hlynsíróp
				for (let key in this.coffee) {
					if (!this.coffee.hasOwnProperty(key)) continue;
					if (this.coffee[key].tones.includes('hunang') || this.coffee[key].tones.includes('vanilla') || this.coffee[key].tones.includes('hlynsíróp')) {
						this.coffee[key].rank++;
					}
				}
			}
			if (this.state.answers[6].answer['Karamellutóna']) {
				// karamella
				for (let key in this.coffee) {
					if (!this.coffee.hasOwnProperty(key)) continue;
					if (this.coffee[key].tones.includes('karamella')) {
						this.coffee[key].rank++;
					}
				}
			}
			if (this.state.answers[6].answer['Hnetutóna']) {
				// hnetur
				for (let key in this.coffee) {
					if (!this.coffee.hasOwnProperty(key)) continue;
					if (this.coffee[key].tones.includes('hnetur')) {
						this.coffee[key].rank++;
					}
				}
			}
			if (this.state.answers[6].answer['Súkkulaðitóna']) {
				// Súkkulaði, kakó
				for (let key in this.coffee) {
					if (!this.coffee.hasOwnProperty(key)) continue;
					if (this.coffee[key].tones.includes('Súkkulaði') || this.coffee[key].tones.includes('kakó')) {
						this.coffee[key].rank++;
					}
				}
			}
			let tmp = [];
			for (let key in this.coffee) {
				if (!this.coffee.hasOwnProperty(key)) continue;
				tmp.push(this.coffee[key]);
			}

			tmp.sort((a, b) => {
				if (a.rank > b.rank) return -1;
				if (a.rank < b.rank) return 1;
				return 0;
			});

			this.state.result = [];
			tmp.forEach((item) => {
				if (item.marker === tmp[0].marker) {
					this.state.result.push(item);
				}
			});

			if (this.current + 1 < 8) {
				if (this.current < 6) {
					this.$emit('show');
				} else {
					this.$emit('hide');
				}
				this.current += 1;
				this.$SmoothScroll(document.getElementById('app'), 300, null, null, 'y');
			}
		},
		answer: function (answer) {
			if (this.state.answers[this.current].multiple) {
				if (this.current === 1) {
					if (answer === 'Svart') {
						this.state.answers[this.current].answer['Svart'] = !this.state.answers[this.current].answer['Svart'];
						this.state.answers[this.current].answer['Með mjólk'] = false;
					} else if (answer === 'Með mjólk') {
						this.state.answers[this.current].answer['Svart'] = false;
						this.state.answers[this.current].answer[answer] = !this.state.answers[this.current].answer[answer];
					} else {
						this.state.answers[this.current].answer[answer] = !this.state.answers[this.current].answer[answer];
					}
				} else {
					this.state.answers[this.current].answer[answer] = !this.state.answers[this.current].answer[answer];
				}
			} else {
				this.state.answers[this.current].answer = answer;
			}
		}
	}
};
</script>

<style lang='less' scoped>
.bold {
	font-weight: bold;
}
.quiz {
	.result-header {
		position: absolute;
		top: 200px;
		text-align: center;
		font-size: 45px;
		width: 100%;
		&.link {
			visibility: hidden;
		}
		@media screen and (max-width: 1366px) {
			&.link {
				font-size: 16px;
				visibility: visible;
				transform: translateY(80px);
			}
		}
		@media screen and (max-width: 768px) {
			font-size: 28px;
		}
		@media screen and (max-width: 440px) {
			&.link {
				font-size: 16px;
				visibility: visible;
				transform: translateY(50px);
			}
		}
		@media screen and (max-width: 392px) {
			&.link {
				transform: translateY(80px);
			}
		}
	}
	.result-back {
		position: absolute;
		bottom: 200px;
		left: 10vw;
		width: 100%;
		.retake {
			display: inline-block;
		}
		.share {
			position: absolute;
			right: 20vw;
			top: 0px;
		}
		@media screen and (max-width: 768px) {
			bottom: 300px;
		}
		@media screen and (max-width: 630px) {
			bottom: 400px;
		}
		@media screen and (max-width: 460px) {
			bottom: 500px;
		}
		@media screen and (max-width: 440px) {
			bottom: 400px;
		}
		@media screen and (max-width: 375px) {
			bottom: 300px;
		}
		&:hover {
			cursor: pointer;
		}
	}
	.view-pad {
		transition: .3s;
		height: 0px;
		&.one {
			height: 1000px;
		}
		&.two {
			height: 100px;
		}
		&.three {
			height: 1000px;
		}
		&.four {
			height: 1000px;
		}
		&.five {
			height: 1000px;
		}
		&.six {
			height: 1000px;
		}
		&.seven {
			height: 1000px;
		}
		&.eight {
			height: 1300px;
		}
		@media screen and (max-width: 1366px) {
			&.one {
				height: 1100px;
			}
			&.two {
				height: 900px;
			}
			&.three {
				height: 1100px;
			}
			&.four {
				height: 800px;
			}
			&.five {
				height: 1100px;
			}
			&.six {
				height: 1000px;
			}
			&.seven {
				height: 1300px;
			}
		}
		@media screen and (max-width: 768px) {
			&.one {
				height: 950px;
			}
			&.two {
				height: 900px;
			}
			&.three {
				height: 1100px;
			}
			&.four {
				height: 800px;
			}
			&.five {
				height: 1000px;
			}
			&.six {
				height: 1000px;
			}
			&.seven {
				height: 1100px;
			}
		}
		@media screen and (max-width: 440px) {
			&.eight {
				height: 2300px;
			}
		}
		@media screen and (max-width: 1366px) {
			&.one {
				height: 1100px;
			}
			&.two {
				height: 900px;
			}
			&.three {
				height: 1100px;
			}
			&.four {
				height: 800px;
			}
			&.five {
				height: 1100px;
			}
			&.six {
				height: 1000px;
			}
			&.seven {
				height: 1300px;
			}
		}
		@media screen and (max-width: 375px) {
			&.one {
				height: 1050px;
			}
			&.two {
				height: 1000px;
			}
			&.three {
				height: 1200px;
			}
			&.four {
				height: 900px;
			}
			&.five {
				height: 1200px;
			}
			&.six {
				height: 1200px;
			}
			&.seven {
				height: 1200px;
			}
		}
	}
	.result {
		position: absolute;
		width: 80vw;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -25%);
		@media screen and (max-width: 440px) {
			transform: translate(-50%, 10%);
		}
		display: grid;
		grid-template-columns: 1fr 1fr 1fr;
		grid-gap: 100px;
		transition: .8s;
		@media screen and (max-width: 1500px) {
			width: 90vw;
			grid-gap: 20px;
		}
		@media screen and (max-width: 1366px) {
			width: 120vw;
			grid-gap: 100px;
			&.left {
				transform: translate(-12%, -25%);
			}
			&.right {
				transform: translate(-88%, -25%);
			}
			.product {
				margin-top: 80px;
			}
		}
		@media screen and (max-width: 1220px) {
			.product {
				margin-top: 40px;
			}
		}
		@media screen and (max-width: 1120px) {
			grid-gap: 100px;
			.product {
				margin-top: 0px;
			}
		}
		@media screen and (max-width: 940px) {
			width: 130vw;
			grid-gap: 50px;
			.product {
				margin-top: 20px;
			}
		}
		@media screen and (max-width: 770px) {
			width: 150vw;
			grid-gap: 40px;
			.product {
				margin-top: 0px;
			}
		}
		@media screen and (max-width: 630px) {
			width: 160vw;
			grid-gap: 30px;
			.product {
				margin-top: -80px;
			}
		}
		@media screen and (max-width: 520px) {
			width: 190vw;
			grid-gap: 20px;
			.product {
				margin-top: -110px;
			}
		}
		@media screen and (max-width: 460px) {
			.product {
				margin-top: -140px;
			}
		}
		@media screen and (max-width: 440px) {
			grid-template-columns: 1fr;
			grid-template-areas:
			'product'
			'product'
			'product';
			width: 80vw;
			grid-gap: 30px;
		}

		.product {
			@media screen and (max-width: 440px) {
				grid-area: product;
			}
			height: 100%;
			min-height: 291px;
			max-height: 730px;
			min-width: 213px;
			max-width: 560px;
			position: relative;
			transition: .3s;
			.backdrop {
				position: absolute;
				height: 100%;
				width: calc(100% + 2px);
				left: -1px;
				top: 1px;
				background-color: #E7CEAC;
				z-index: 2;
				@media screen and (max-width: 630px) {
					height: calc(100% + 20px);
				}
				@media screen and (max-width: 440px) {
					height: calc(100% - 40px);
				}

				@media screen and (max-width: 392px) {
					height: calc(100% - 125px);
				}
			}
			.title, .top, .center, .backdrop {
				@media screen and (max-width: 440px) {
					transform: translateY(40px);
				}
				@media screen and (max-width: 392px) {
					transform: translateY(125px);
				}
				transition: .3s;
				opacity: 0;
			}
			.bottom {
				.left {
					@media screen and (max-width: 440px) {
						transform: translateY(40px);
					}
					@media screen and (max-width: 392px) {
						transform: translateY(125px);
					}
					transition: .3s;
					opacity: 0;
				}
				.right {
					@media screen and (max-width: 440px) {
						transform: translateY(40px);
					}
					@media screen and (max-width: 392px) {
						transform: translateY(125px);
					}
					transition: .3s;
					opacity: 0;
				}
			}
			&:hover {
				cursor: pointer;
				.title, .top, .center, .backdrop {
					opacity: 1;
				}
				.bottom {
					.left {
						opacity: 1;
					}
					.right {
						opacity: 1;
					}
				}
			}
			@media screen and (max-width: 1366px) and (min-width: 441px) {
				opacity: .6;
				&.focus {
					opacity: 1;
				}
				&:hover {
					cursor: pointer;
					opacity: 1;
				}
			}
			@media screen and (max-width: 440px) {
				&.product1 {
					margin-top: -860px;
					transform: translateY(-80px);
				}
				&.product2 {
					margin-top: -320px;
					transform: translateY(-110px);
				}
				&.product3 {
					margin-top: 230px;
					transform: translateY(-150px);
				}
			}
			.img {
				width: 100%;
				min-height: 291px;
				min-width: 213px;
				bottom: 0px;
				position: absolute;
				left: 50%;
				transform: translateX(-50%);
				transition: 0s;
				z-index: 1;
				opacity: 1;
			}
			.top {
				z-index: 2;
				position: relative;
				top: -6px;
				.description {
					padding-top: 10px;
					padding-bottom: 10px;
					border-bottom: 2px solid black;
					@media screen and (max-width: 940px) {
						font-size: 14px;
					}
				}
				padding-left: 10px;
				padding-right: 10px;
			}
			.center {
				z-index: 2;
				position: relative;
				top: -6px;
				display: grid;
				grid-template-columns: 1.8fr 2fr;
				min-height: 80px;
				.uppahelling {
					border-right: 2px solid black;
					p {
						margin: 0px;
						padding-right: 10px;
						@media screen and (max-width: 940px) {
							font-size: 14px;
						}
						&.head {
							padding-top: 10px;
							font-size: 14px;
							@media screen and (max-width: 940px) {
								font-size: 12px;
							}
						}
					}
					border-bottom: 2px solid black;
					margin-left: 10px;
				}
				.locations {
					p {
						margin: 0px;
						padding-left: 10px;
						@media screen and (max-width: 940px) {
							font-size: 14px;
						}
						&.head {
							padding-top: 10px;
							font-size: 14px;
							@media screen and (max-width: 940px) {
								font-size: 12px;
							}
						}
					}
					padding-bottom: 10px;
					border-bottom: 2px solid black;
					margin-right: 10px;
				}
			}
			.bottom {
				position: relative;
				top: -6px;
				display: grid;
				grid-template-columns: 1.8fr 2fr;
				.left {
					z-index: 2;
					padding-top: 10px;
					border-right: 2px solid black;
					padding-bottom: 20px;
					.dot {
						border: 2px solid black;
						border-radius: 50%;
						width: 14px;
						height: 14px;
						transition: .3s;
						&.active {
							background-color: black;
						}
						@media screen and (max-width: 630px) {
							width: 10px;
							height: 10px;
						}
						@media screen and (max-width: 520px) {
							transform: translate(-50px, 20px);
							margin-right: 5px;
						}
					}
					.brennsla {
						z-index: 2;
						padding-bottom: 10px;
						display: grid;
						grid-template-columns: 1fr 1fr 1fr 1fr;
						p {
							min-width: 60px;
							padding-left: 10px;
							margin: 0px;
							@media screen and (max-width: 940px) {
								min-width: 50px;
								font-size: 14px;
							}
							@media screen and (max-width: 520px) {
								padding-bottom: 10px;
							}
						}
					}
					.fylling {
						z-index: 2;
						padding-bottom: 10px;
						display: grid;
						grid-template-columns: 1fr 1fr 1fr 1fr;
						p {
							min-width: 60px;
							padding-left: 10px;
							margin: 0px;
							@media screen and (max-width: 940px) {
								min-width: 50px;
								font-size: 14px;
							}
							@media screen and (max-width: 520px) {
								padding-bottom: 10px;
							}
						}
					}
					.avoxtur {
						z-index: 2;
						display: grid;
						grid-template-columns: 1fr 1fr 1fr 1fr;
						p {
							min-width: 60px;
							padding-left: 10px;
							margin: 0px;
							@media screen and (max-width: 940px) {
								min-width: 50px;
								font-size: 14px;
							}
							@media screen and (max-width: 520px) {
								padding-bottom: 10px;
							}
						}
					}
				}
				.right {
					z-index: 2;
					padding-top: 10px;
					padding-left: 10px;
					padding-bottom: 20px;
					.above {
						.bondi {
							font-size: 14px;
							@media screen and (max-width: 940px) {
								font-size: 12px;
							}
						}
						p {
							margin: 0px;
							@media screen and (max-width: 940px) {
								font-size: 14px;
							}
						}
					}
					.below {
						.yrki {
							padding-top: 20px;
							font-size: 14px;
							@media screen and (max-width: 940px) {
								font-size: 12px;
							}
						}
						p {
							margin: 0px;
							@media screen and (max-width: 940px) {
								font-size: 14px;
							}
						}
					}
				}
			}
		}
		&.hidden {
			opacity: 0;
			pointer-events: none;
			transform: translate(-50%, 30%);
		}
	}
	.quiz-container {
		position: absolute;
		text-align: center;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%);
		display: grid;
		grid-template-areas:
		"left left left question question question right right right"
		"left left left information information information right right right"
		"left left left row1 row1 row1 right right right"
		"left left left row2 row2 row2 right right right"
		"left left left skip skip skip right right right";
		&.one {
			.answer-row-1 {
				position: relative;
				grid-template-areas: 'answer1 answer2 answer3 answer4';
				@media screen and (max-width: 1366px) {
					max-width: 310px;
					grid-gap: 30px;
					grid-template-areas:
					'answer1 answer2'
					'answer3 answer4';
				}
				@media screen and (max-width: 1366px) {
					max-width: 240px;
				}
			}
			.answer-row-2 {
				position: relative;
				grid-template-areas: 'answer5 answer6 answer7';
				@media screen and (max-width: 1366px) {
					max-width: 310px;
					margin-top: 10px;
					grid-gap: 30px;
					grid-template-areas:
					'answer5 answer6'
					'answer7 answer7';
				}
				@media screen and (max-width: 1366px) {
					max-width: 240px;
				}
			}
			.skip {
				position: relative;
				height: 20px;
				left: calc(50% - 45px);
				width: 797px;
				@media screen and (max-width: 1366px) {
					width: 312px;
					left: calc(50% - 40px);
				}
				@media screen and (max-width: 768px) {
					left: calc(50% - 60px);
					width: 240px;
				}
				transform: translateX(-50%);
			}
		}
		&.two {
			.answer-row-1 {
				grid-template-areas: 'answer1 answer2 answer3';
				&.grid {
					margin-left: auto;
					margin-right: auto;
					width: 100%;
				}
				@media screen and (max-width: 1366px) {
					grid-gap: 30px;
					grid-template-areas:
					'answer1'
					'answer2'
					'answer3';
				}
			}
			.skip {
				@media screen and (max-width: 1366px) {
					width: 312px;
					left: calc(50% - 60px);
					transform: translateX(-50%);
					.next {
						margin-right: 0px !important;
					}
					.back {
						margin-left: 0px !important;
					}
					.underline {
						&.active {
							right: 0px;
						}
					}
				}
				@media screen and (max-width: 768px) {
					.next {
						margin-right: 40px !important;
					}
					.back {
						margin-left: 40px !important;
					}
					.underline {
						&.active {
							right: 40px;
						}
					}
				}
			}
		}
		&.three {
			.answer-row-1 {
				grid-template-areas: 'answer1 answer2 answer3';
			}
			@media screen and (max-width: 1366px) {
				.skip {
					width: 300px;
					transform: translate(234px, -100px);
					left: 0%;
				}
			}
		}
		&.four {
			.answer-row-1 {
				grid-template-areas: 'answer1 answer2 answer3 answer4';
				@media screen and (max-width: 1366px) {
					grid-gap: 30px;
					grid-template-areas:
					'answer1 answer2'
					'answer3 answer4';
					max-width: 312px;
				}
			}
			.skip {
				@media screen and (max-width: 1366px) {
					width: 312px;
					left: calc(50% - 60px);
					transform: translateX(-50%);
					.next {
						margin-right: 9px !important;
					}
					.back {
						margin-left: 9px !important;
					}
				}
			}
		}
		&.seven {
			grid-template-areas:
			"left left left question question question right right right"
			"left left left information information information right right right"
			"left left left row1 row1 row1 right right right"
			"left left left row2 row2 row2 right right right"
			"left left left skip skip skip right right right";
			.answer-row-1 {
				grid-gap: 20px;
				grid-template-areas:
				'answer1 answer2 answer3 answer4 answer5'
				'answer6 answer7 answer8 answer9 answer10';
			}
			@media screen and (max-width: 1366px) {
				.answer-row-1 {
					max-width: 310px;
					grid-template-areas:
					'answer1 answer2'
					'answer3 answer4'
					'answer5 answer6'
					'answer7 answer8'
					'answer9 answer10';
				}
			}
		}
		grid-gap: 20px;
		transition: .8s;
		transition-timing-function: ease;
		opacity: 1;
		&.left {
			opacity: 0;
			pointer-events: none;
			transform: translate(-50%, -150%);
		}
		&.right {
			opacity: 0;
			pointer-events: none;
			transform: translate(-50%, 50%);
		}
		.question {
			grid-area: question;
			font-size: 45px;
			@media screen and (max-width: 1366px) {
				.para {
					padding-left: 150px;
					padding-right: 150px;
				}
			}
			@media screen and (max-width: 768px) {
				.para {
					padding-left: 250px;
					padding-right: 250px;
					font-size: 28px;
				}
			}
		}
		.information {
			margin-left: auto;
			margin-right: auto;
			width: 770px;
			grid-area: information;
			margin-bottom: 30px;
			@media screen and (max-width: 1366px) {
				.para {
					padding-left: 150px;
					padding-right: 150px;
				}
			}
			@media screen and (max-width: 1366px) {
				.para {
					padding-left: 250px;
					padding-right: 250px;
				}
			}
		}
		.pad-left {
			grid-area: left;
		}
		.pad-right {
			grid-area: right;
		}
		.answer-row-1 {
			&.grid {
				margin-left: auto;
				margin-right: auto;
				width: 100%;
				grid-area: row1;
				display: grid;
			}
			&.slider {
				grid-area: row1;
				position: relative;
				.line {
					height: 10px;
					width: 100%;
					background-color: #181617;
					border-radius: 10px;
				}
				.bean {
					background-image: url('../assets/bean.png');
					position: absolute;
					top: -21px;
					height: 51px;
					width: 51px;
					transition: .5s;
					&.left {
						left: 0%;
						transform: translateX(0%);
					}
					&.center {
						left: 50%;
						transform: translateX(-50%);
					}
					&.right {
						left: 100%;
						transform: translateX(-100%);
					}
				}
				@media screen and (max-width: 1366px) {
					height: 500px;
					.line {
						height: 400px;
						width: 10px;
						position: absolute;
						left: 50%;
						transform: translateX(-50%);
					}
					.bean {
						position: absolute;
						transition: .5s;
						&.left {
							top: 20px;
							left: 50%;
							transform: translate(-50%, -50%);
						}
						&.center {
							top: 190px;
							left: 50%;
							transform: translate(-50%, -50%);
						}
						&.right {
							top: 380px;
							left: 50%;
							transform: translate(-50%, -50%);
						}
					}
				}
			}
		}
		.answer-row-2 {
			position: relative;
			&.grid {
				margin-left: auto;
				margin-right: auto;
				width: 866px;
				&.no-width {
					width: auto;
				}
				grid-area: row2;
				display: grid;
			}
			&.slider  {
				grid-area: row2;
				display: grid;
				grid-template-columns: 1fr 1fr 1fr;
				.section {
					transition: .2s;
					&.section-1 {
						padding-top: 50px;
						transform: translateY(-50px);
						text-align: left;
					}
					&.section-2 {
						padding-top: 50px;
						transform: translateY(-50px);
						text-align: center;
					}
					&.section-3 {
						padding-top: 50px;
						transform: translateY(-50px);
						text-align: right;
					}
					&.active {
						color: #E97B31;
					}
					&:hover {
						color: #E97B31;
					}
				}
				@media screen and (max-width: 1366px) {
					display: inline;
					.section {
						position: relative;
						transition: .2s;
						&.section-1 {
							position: absolute;
							width: 200px;
							height: 100px;
							line-height: 5px;
							transform: translate(200px, -550px);
							top: 0px;
							text-align: left;
							padding-left: 40px;
						}
						&.section-2 {
							position: absolute;
							width: 200px;
							height: 100px;
							line-height: 40px;
							transform: translate(310px, -400px);
							top: 0px;
							text-align: right;
						}
						&.section-3 {
							position: absolute;
							width: 200px;
							height: 100px;
							line-height: 125px;
							transform: translate(200px, -250px);
							top: 0px;
							text-align: left;
							padding-left: 40px;
						}
						&.active {
							color: #E97B31;
						}
						&:hover {
							color: #E97B31;
						}
					}
				}
				@media screen and (max-width: 768px) {
					font-size: 14px;
					.section {
						&.section-1 {
							transform: translate(210px, -550px);
						}
						&.section-2 {
							transform: translate(320px, -400px);
						}
						&.section-3 {
							transform: translate(210px, -250px);
						}
					}
				}
			}
		}
		.padding-left {
			grid-area: padderleft;
		}
		.padding-right {
			grid-area: padderright;
		}
		.answer-1 {
			grid-area: answer1;
		}
		.answer-2 {
			grid-area: answer2;
		}
		.answer-3 {
			grid-area: answer3;
		}
		.answer-4 {
			grid-area: answer4;
		}
		.answer-5 {
			grid-area: answer5;
		}
		.answer-6 {
			grid-area: answer6;
		}
		.answer-7 {
			grid-area: answer7;
		}
		.answer-8 {
			grid-area: answer8;
		}
		.answer-9 {
			grid-area: answer9;
		}
		.answer-10 {
			grid-area: answer10;
		}
		.skip {
			position: relative;
			margin-top: 20px;
			grid-area: skip;
			display: grid;
			grid-template-columns: 1fr 1fr;
			.underline {
				height: 2px;
				top: 23px;
				width: 0px;
				background-color: #181617;
				position: absolute;
				right: 103px;
				transition: .8s;
				transition-timing-function: ease;
				&.active {
					width: 95px;
					right: 8px;
				}
				&.first {
					right: 115px;
					&.active {
						width: 95px;
						right: 0px;
					}
				}
			}
			.next {
				position: absolute;
				right: 0px;
				transition: .3s;
				text-align: right;
				transform: translateY(0px);
				&:hover {
					transform: translateY(-3px);
				}
			}
			.back {
				position: absolute;
				left: 0px;
				padding-left: 5px;
				transition: .3s;
				text-align: left;
				transform: translateY(0px);
				&:hover {
					transform: translateY(-3px);
				}
			}
			&.no-back {
				.back {
					padding-left: 55px;
				}
			}
		}
		&.two {
			.underline {
				right: 143px;
				transition: .8s;
				transition-timing-function: ease;
				width: 0px;
				&.active {
					width: 95px;
					right: 40px;
				}
				&.first {
					right: 115px;
					&.active {
						width: 95px;
						right: 0px;
					}
				}
			}
			.skip {
				.next {
					margin-right: 40px;
				}
				.back {
					margin-left: 40px;
				}
			}
		}
		&.four, &.three, &.five, &.six {
			.skip {
				.next {
					margin-right: 9px;
				}
				.back {
					margin-left: 9px;
				}
			}
		}
		&.five, &.six {
			@media screen and (max-width: 1366px) {
				.skip {
					width: 300px;
					transform: translate(234px, -100px);
					left: 0%;
				}
			}
		}
		&.seven {
			.skip {
				.underline {
					right: 143px;
					transition: .8s;
					transition-timing-function: ease;
					width: 0px;
					&.active {
						width: 65px;
						right: 0px;
					}
				}
				@media screen and (max-width: 1366px) {
					width: 300px;
					transform: translateX(234px);
				}
			}
		}
		.answer {
			position: relative;
			margin-left: auto;
			margin-right: auto;
			font-size: 20px;
			border: 2px solid black;
			line-height: 155px;
			@media screen and (max-width: 768px) {
				line-height: 150px;
			}
			width: 178px;
			height: 155px;
			transition: .5s;
			&.no-brew {
				line-height: 25px;
				p {
					padding-top: 30px;
				}
				&.active {
					line-height: 25px;
				}
				&:hover {
					line-height: 25px;
				}
			}
			@media screen and (min-width: 1367px) {
				&.odd {
					width: 251px;
				}
			}
			@media screen and (max-width: 1366px) {
				width: 138px;
				height: 120px;
				font-size: 16px;
				&.wide {
					width: 310px;
				}
			}
			@media screen and (max-width: 768px) {
				width: 103px;
				height: 90px;
				font-size: 12px;
				&.wide {
					width: 240px;
				}
			}
			&.active {
				line-height: 255px;
				@media screen and (max-width: 1366px) {
					line-height: 190px;
				}
				@media screen and (max-width: 768px) {
					line-height: 150px !important;
				}
				border: 2px solid rgba(0,0,0,0);
				.icon {
					opacity: 1;
					transition: .5s;
					transition-delay: .2s;
					transition-timing-function: ease;
				}
				&::after {
					opacity: 1;
					z-index: -1;
				}
				&.no-icon {
					line-height: 155px;
				}
			}
			&:hover {
				line-height: 255px;
				@media screen and (max-width: 1366px) {
					line-height: 190px;
				}
				@media screen and (max-width: 768px) {
					line-height: 150px !important;
				}
				border: 2px solid rgba(0,0,0,0);
				.icon {
					opacity: 1;
					transition: .5s;
					transition-delay: .2s;
					transition-timing-function: ease;
				}
				&::after {
					opacity: 1;
					z-index: -1;
				}
				&.no-icon {
					line-height: 155px;
				}
				&.no-brew {
					line-height: auto;
				}
			}
			&::after {
				content: "";
				transition: .3s;
				background-image: url('../assets/button.jpg');
				opacity: 0;
				top: -1px;
				left: -1px;
				bottom: 0;
				right: 0;
				width: 181px;
				height: 157px;
				position: absolute;
				@media screen and (max-width: 1366px) {
					width: 140px;
					height: 122px;
				}
				@media screen and (max-width: 768px) {
					width: 105px;
					height: 92px;
				}
			}
			&.odd {
				&::after {
					width: 254px;
					@media screen and (max-width: 1366px) {
						width: 140px;
						height: 122px;
					}
					@media screen and (max-width: 768px) {
						width: 105px;
						height: 92px;
					}
				}
			}
			&.wide {
				&::after {
					@media screen and (max-width: 1366px) {
						width: 312px;
						height: 122px;
					}
					@media screen and (max-width: 768px) {
						width: 242px;
						height: 92px;
					}
				}
			}
			.icon {
				background-size: cover;
				position: absolute;
				bottom: 50px;
				margin-left: auto;
				margin-right: auto;
				opacity: 0;
				@media screen and (max-width: 768px) {
					bottom: 35px;
				}
			}
			@media screen and (max-width: 1366px) {
				line-height: 190px;
				.icon {
					opacity: 1;
					transition: .5s;
					transition-delay: .2s;
					transition-timing-function: ease;
				}
				&.no-icon {
					line-height: 155px;
				}
			}
			@media screen and (max-width: 768px) {
				line-height: 140px;
			}
		}
		// Icons
		&.seven {
			.answer {
				&.answer-1 {
					.icon {
						background-image: url('../assets/icons/citrus.svg');
						width: 70px;
						height: 70px;
						left: 50%;
						transform: translateX(-50%);
						@media screen and (max-width: 1366px) {
							width: 50px;
							height: 50px;
						}
					}
				}
				&.answer-2 {
					.icon {
						background-image: url('../assets/icons/berry.svg');
						width: 70px;
						height: 73px;
						left: 50%;
						transform: translateX(-50%);
						@media screen and (max-width: 1366px) {
							width: 48px;
							height: 50px;
						}
					}
				}
				&.answer-3 {
					.icon {
						background-image: url('../assets/icons/fruit.svg');
						height: 70px;
						width: 59px;
						left: 50%;
						transform: translateX(-50%);
						@media screen and (max-width: 1366px) {
							width: 40px;
							height: 47px;
						}
					}
				}
				&.answer-4 {
					.icon {
						background-image: url('../assets/icons/floral.svg');
						width: 76px;
						height: 82px;
						left: 50%;
						transform: translateX(-50%);
						@media screen and (max-width: 1366px) {
							width: 46px;
							height: 50px;
						}
					}
				}
				&.answer-5 {
					.icon {
						background-image: url('../assets/icons/spices.svg');
						width: 95px;
						height: 83px;
						left: 50%;
						transform: translateX(-50%);
						@media screen and (max-width: 1366px) {
							width: 56px;
							height: 50px;
						}
					}
				}
				&.answer-6 {
					.icon {
						background-image: url('../assets/icons/burnt.svg');
						width: 77px;
						height: 73px;
						left: 50%;
						transform: translateX(-50%);
						@media screen and (max-width: 1366px) {
							width: 53px;
							height: 50px;
						}
					}
				}
				&.answer-7 {
					.icon {
						background-image: url('../assets/icons/sweet.svg');
						width: 52px;
						height: 80px;
						left: 50%;
						transform: translateX(-50%);
						@media screen and (max-width: 1366px) {
							width: 32px;
							height: 50px;
						}
					}
				}
				&.answer-8 {
					.icon {
						background-image: url('../assets/icons/caramel.svg');
						width: 79px;
						height: 34px;
						left: 50%;
						transform: translateX(-50%);
						@media screen and (max-width: 1366px) {
						width: 79px;
						height: 34px;
						}
					}
				}
				&.answer-9 {
					.icon {
						background-image: url('../assets/icons/nuts.svg');
						width: 55px;
						height: 53px;
						left: 50%;
						transform: translateX(-50%);
						@media screen and (max-width: 1366px) {
							width: 52px;
							height: 50px;
						}
					}
				}
				&.answer-10 {
					.icon {
						background-image: url('../assets/icons/chocolate.svg');
						width: 57px;
						height: 96px;
						left: 50%;
						transform: translateX(-50%);
						@media screen and (max-width: 1366px) {
							width: 30px;
							height: 50px;
						}
					}
				}
			}
		}
		&.two {
			.answer {
				&.answer-1 {
					.icon {
						background-image: url('../assets/icons/black.svg');
						width: 103px;
						height: 66px;
						left: 50%;
						transform: translateX(-50%);
						@media screen and (max-width: 1366px) {
							width: 62px;
							height: 40px;
						}
					}
				}
				&.answer-2 {
					.icon {
						background-image: url('../assets/icons/milk.svg');
						width: 88px;
						height: 80px;
						left: 50%;
						transform: translateX(-50%);
						@media screen and (max-width: 1366px) {
							width: 55px;
							height: 50px;
						}
					}
				}
				&.answer-3 {
					.icon {
						background-image: url('../assets/icons/decaf.svg');
						width: 94px;
						height: 64px;
						@media screen and (max-width: 1366px) {
							width: 66px;
							height: 45px;
						}
						left: 50%;
						transform: translateX(-50%);
					}
				}
			}
		}
		&.one {
			.answer {
				&.answer-1 {
					.icon {
						background-image: url('../assets/icons/press.svg');
						width: 66px;
						height: 82px;
						@media screen and (max-width: 1366px) {
							width: 48px;
							height: 60px;
						}
						@media screen and (max-width: 768px) {
							width: 32px;
							height: 40px;
						}
						left: 50%;
						transform: translateX(-50%);
					}
				}
				&.answer-2 {
					.icon {
						background-image: url('../assets/icons/slowbrew.svg');
						width: 71px;
						height: 82px;
						@media screen and (max-width: 1366px) {
							width: 52px;
							height: 60px;
						}
						@media screen and (max-width: 768px) {
							width: 35px;
							height: 40px;
						}
						left: 50%;
						transform: translateX(-50%);
					}
				}
				&.answer-3 {
					.icon {
						background-image: url('../assets/icons/mokka.svg');
						width: 76px;
						height: 82px;
						@media screen and (max-width: 1366px) {
							width: 56px;
							height: 60px;
						}
						@media screen and (max-width: 768px) {
							width: 38px;
							height: 40px;
						}
						left: 50%;
						transform: translateX(-50%);
					}
				}
				&.answer-4 {
					.icon {
						background-image: url('../assets/icons/machine.svg');
						width: 69px;
						height: 82px;
						@media screen and (max-width: 1366px) {
							width: 50px;
							height: 60px;
						}
						@media screen and (max-width: 768px) {
							width: 34px;
							height: 40px;
						}
						left: 50%;
						transform: translateX(-50%);
					}
				}
				&.answer-5 {
					.icon {
						background-image: url('../assets/icons/slow.svg');
						width: 29px;
						height: 82px;
						@media screen and (max-width: 1366px) {
							width: 18px;
							height: 50px;
						}
						@media screen and (max-width: 768px) {
							width: 12px;
							height: 35px;
						}
						left: 50%;
						transform: translateX(-50%);
					}
				}
				&.answer-6 {
					.icon {
						background-image: url('../assets/icons/expresso.svg');
						width: 73px;
						height: 74px;
						@media screen and (max-width: 1366px) {
							width: 59px;
							height: 60px;
						}
						@media screen and (max-width: 768px) {
							width: 39px;
							height: 40px;
						}
						left: 50%;
						transform: translateX(-50%);
					}
				}
				&.answer-7 {
					.icon {
						background-image: url('../assets/icons/aero.svg');
						width: 61px;
						height: 82px;
						@media screen and (max-width: 1366px) {
							width: 45px;
							height: 60px;
						}
						@media screen and (max-width: 768px) {
							width: 30px;
							height: 40px;
						}
						left: 50%;
						transform: translateX(-50%);
					}
				}
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue